export default function create(options) {
  const {
    speed = 1.5,
    reverse = false
  } = options.namedEffect;
  let start = -100 * (speed - 1) / speed;
  let end = 0;
  if (reverse) {
    [start, end] = [end, start];
  }
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: `translateY(${start}%)`
    }, {
      transform: `translateY(${end}%)`
    }]
  }];
}
//# sourceMappingURL=ImageParallax.js.map